// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M6 2H18V4H17V8H7V4H6V2ZM11 4.49805V6.50195H13.0039V4.49805H11Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M5 10H8V23H2V19H3V16H4L4 13H5V10Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M14 10H10V23H14V10Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M19 10H16V23H22V19H21V16H20V13H19V10Z"}}]};

const PyramidMayaFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'pyramid-maya-filled',
    ref,
    icon: element,
  },
));

PyramidMayaFilledIcon.displayName = 'PyramidMayaFilledIcon';

export default PyramidMayaFilledIcon;
